<div
  class="tw-border-solid tw-border-0 tw-border-t tw-border-t-secondary-500 tw-my-2"
  role="separator"
></div>
